"use strict";
import React from "react";
import { Link } from "react-router-dom"
import { Modal, Button } from "react-bootstrap";

const initComponent = (flex = window.flex) => {

    class VinSearch extends React.Component {
        state = {
            showModal: false,
            isModalOpen: false,
            Vin: [],
            landingPoint: "VDP",
            currentView: ""
        };

        getDestination = (currentfunction) => {
            let landingPoint = "VDP";
            let currentView = "";

            if (currentfunction != null && !_.isEmpty(currentfunction)) {
                let value = currentfunction.quickSearchKey;
                currentView = currentfunction.code;

                if (value != undefined || value != null) {
                    landingPoint = value != "" ? value : landingPoint;
                }
            }

            this.setState({ landingPoint: landingPoint, currentView: currentView });
        };

        getConfiguration = () => {
            const msg = { RoleId: 0 };
            let config = {};
            var moduleName = "/api/v1/workbench";

            $.ajax({
                url: flex.getApiUrl(moduleName + "/getworkbenchconfigbyroles"),
                async: false,
                type: "POST",
                dataType: "json",
                data: JSON.stringify(msg),
                contentType: "application/json",
                headers: flex.getHeaders(),
                success: function (data) {
                    config = data;
                    let functions = config.workBenchConfig.functions.filter(function (fun) { return fun.enabled; });
                    functions = _.sortBy(functions, 'order', function (n) { return Math.sin(n); });
                    let currentfunction = functions.length > 0 ? functions[0] : {};
                    this.getDestination(currentfunction);
                }.bind(this),
                error: (jqXHR, textStatus, errorThrown) => {
                    flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                    this.getDestination(null);
                }
            });
        };

        componentDidMount() {
            this.getConfiguration();
        }

        open = () => {
            this.setState({ showModal: true });
        };

        close = () => {
            this.setState({ showModal: false });
        };

        navigateToWorkBench = () => {
            let currentView = this.state.currentView;
            let value = this.state.vinText;
            let url = "/inventory/listing/" + currentView + "/" + value;
            window.location.href = url;
        };

        showError = () => {
            this.setState({ showModal: false });
            var error = flex.text("VIN_IS_MANDATORY", "VIN is Mandatory");
            var param = { message: error, type: "error" }
            flex.trigger("global:showAlert", param);
        };

        showModal = (params) => {
            flex.trigger("global:vinSearch", params);
            this.setState({ showModal: true });
        };

        getsearchbyvin = () => {
            flex.setStore({ Vin: [], singleVin: [] });
            let landingPage = this.state.landingPoint;
            let params = { vin: this.state.vinText };

            if (params.vin == undefined || params.vin == "") {
                this.showError();
                return;
            }

            if (landingPage == "Workbench") {
                this.navigateToWorkBench();
            }
            else {
                this.showModal(params);
            }
        };

        handleVinChange = (e) => {
            this.setState({ vinText: e.target.value });
        };

        handleKeyPress = (event) => {
            if (event.keyCode == 13) {
                this.getsearchbyvin();
            }
        };

        render() {
            const store = flex.getStore(true);
            let vintest = store.Vin || [];
            let singleVin = store.singleVin || [];
            let sample = singleVin.length == 1 ? window.location.href = "/inventory/vehicleDetail/" + singleVin[0].id : null;
            let style = { width: "200px" };
            const url = "/inventory/vehicleDetail/";
            var rows = [];

            $.each(vintest, function (item, obj) {
                var row = <tr>
                    <td><Link to={url + obj.id}>{obj.vin}</Link></td>
                    <td>&nbsp;&nbsp;{obj.createdDate}</td>
                </tr>
                rows.push(row);
            }

            );
            return (
                <div className="col-sm-3 vin-search-container" style={{ float: "right", zIndex: 1 }}>
                    <div className="input-group">
                        <input className="form-control"
                            id="vin"
                            name="vin"
                            maxLength="17"
                            placeholder="Search for VIN"
                            type="text"
                            value={this.state.vinText}
                            onKeyDown={this.handleKeyPress}
                            onChange={this.handleVinChange} />

                        <span className="input-group-btn vinSearchBtn">
                            <button className="btn label-spacing" onClick={this.getsearchbyvin}>GO</button>
                            <Modal show={this.state.showModal && rows.length > 1} onHide={this.close} dialogClassName="workbench-VDP-modal">
                                <Modal.Header closeButton>
                                </Modal.Header>
                                <Modal.Body>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>VIN&nbsp;</th>
                                                <th>CreatedDate</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows}
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button onClick={this.close}>Close</Button>
                                </Modal.Footer>
                            </Modal>
                        </span>
                    </div>
                </div>
            );
        }
    }

    return VinSearch;
};

module.exports = initComponent;
